
export const awsmobile = {
    aws_appsync_graphqlEndpoint: "https://f3z4chnqpfhnndy3f5m4uupq4m.appsync-api.ap-southeast-1.amazonaws.com/graphql",
    aws_appsync_region: "ap-southeast-1",
    aws_appsync_authenticationType: "AMAZON_COGNITO_USER_POOLS",
    aws_cognito_region: "ap-southeast-1",
    aws_user_pools_id: "ap-southeast-1_X2FzUdsFK",
    aws_user_pools_web_client_id: "7dpaiefsjaorg8qa37f36d9v0n",
    preview_domain: "auth.traderflow.com",
    sso_redirect_uri: "https://app.traderflow.com/",
    aws_user_pool_domain: "traderflow-sso.auth.ap-southeast-1.amazoncognito.com",
    competition_bucket_url: "https://tf-api-competitionsbucket89235cd2-6vw0e0g1luzf.s3.ap-southeast-1.amazonaws.com",
    websocket_url: "wss://1cln6trn7d.execute-api.ap-southeast-1.amazonaws.com/prod",
    forex_copilot_api_url: "",
    oauth: {
        domain: "traderflow-sso.auth.ap-southeast-1.amazoncognito.com",
        scope: ["email", "openid", "profile"],
        redirectSignIn: "https://app.traderflow.com/",
        redirectSignOut: "https://app.traderflow.com/",
        responseType: "code"
    },
    federationTarget: "COGNITO_USER_POOLS",
    aws_cognito_social_providers: ["FACEBOOK", "GOOGLE", "APPLE"]
};
export default awsmobile;

